import { get, put, post, del } from "../../utils/axios/axios.config";

class CommonServices {
  constructor(url) {
    this.url = url;
  }

  async getAll(params) {
    try {
      const response = await get(this.url, { params });
      return response;
    } catch (error) {
      throw error?.response?.data || error?.message;
    }
  }

  async getById(id) {
    try {
      const response = await get(`${this.url}/${id}`);
      return response;
    } catch (error) {
      throw error?.response?.data || error?.message;
    }
  }

  async createOne(data) {
    try {
      const response = await post(this.url, data);
      return response;
    } catch (error) {
      throw error?.response?.data || error?.message;
    }
  }

  async updateById(id, data) {
    try {
      const response = await put(`${this.url}/${id}`, data);
      return response;
    } catch (error) {
      throw error?.response?.data || error?.message;
    }
  }

  async deleteById(id) {
    try {
      const response = await del(`${this.url}/${id}`);
      return response;
    } catch (error) {
      throw error?.response?.data || error?.message;
    }
  }
}

export default CommonServices;